<template>
  <v-card
    class="my-1 d-flex flex-column"
    elevation="2"
    style="height: 100%; width: 100%;"
  >
    <v-card-title class="d-flex align-center">
      <h5>Top 10 - PSFP</h5>

      <v-spacer />

      <span class="caption grey--text mr-2"> {{ selectedCount }}/10 </span>

      <v-btn
        text
        small
        :disabled="loading || !selectedCount"
        @click="$emit('limpar-selecao')"
      >
        Limpar
      </v-btn>

      <v-btn
        color="primary"
        small
        class="ml-2"
        :loading="loading"
        :disabled="loading || selectedCount < 2"
        @click="$emit('simular')"
      >
        Simular
      </v-btn>
    </v-card-title>
    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="height: 300px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-card-text v-else class="flex-grow-1 d-flex flex-column">
      <v-data-table
        :headers="[
          { text: '#', value: 'index', width: '20px', sortable: false },
          {
            text: 'Índice',
            value: 'indice_categoria',
            align: 'center',
            sortable: false,
          },
          { text: 'Serviço', value: 'servico', sortable: false },
          { text: 'SA', value: 'sa', align: 'center', sortable: false },
          { text: 'SFP', value: 'sfp', align: 'center', sortable: false },
          { text: 'PSFP', value: 'psfp', align: 'center', sortable: false },
          {
            text: 'CPISFP',
            value: 'contribuicao_ponderada_isfp',
            align: 'center',
            sortable: false,
          },
          {
            text: '',
            value: 'acoes',
            align: 'center',
            width: '44px',
            sortable: false,
          },
        ]"
        :items="topPsfp.slice(0, 10).map((d, i) => ({ ...d, index: i + 1 }))"
        hide-default-footer
        disable-pagination
        class="flex-grow-1 tabela-top10-simulador tabela-top10-compacta"
        dense
      >
        <template v-slot:header.acoes>
          <span
            class="grey--text d-inline-flex justify-center"
            style="font-size: 1.05rem; line-height: 1; user-select: none; width: 100%;"
          >⋮</span>
        </template>

        <template v-slot:item.index="{ item }">
          {{ item.index }}
        </template>
        <template v-slot:item.indice_categoria="{ item }">
          {{ item.indice_categoria }}
        </template>
        <template v-slot:item.servico="{ item }">
          <div>
            <strong>{{ item.codigos_servico }}</strong>
            <v-tooltip v-if="Number(item.sa) <= 10" right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="warning" class="ml-1">
                  mdi-alert
                </v-icon>
              </template>
              <span
                >PSFP alto com volume baixo (SA ≤ 10) — possível efeito
                denominador.</span
              >
            </v-tooltip>
          </div>
          <div style="font-size: 12px; color: #888;">
            {{ item.nome_por_indice }}
          </div>
        </template>

        <template v-slot:item.sa="{ item }">
          {{ item.sa | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template v-slot:item.sfp="{ item }">
          {{ item.sfp | parseNumberToFloatBrIgnoringNaN }}
        </template>

        <template v-slot:header.sa="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" class="text-no-wrap">
                {{ header.text }}
                <v-icon x-small color="grey">mdi-help-circle-outline</v-icon>
              </span>
            </template>
            <span>
              Sa = quantidade de serviços executados pela distribuidora em cada
              categoria de serviço comercial <i>i</i>.
            </span>
          </v-tooltip>
        </template>

        <template v-slot:header.sfp="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" class="text-no-wrap">
                {{ header.text }}
                <v-icon x-small color="grey">mdi-help-circle-outline</v-icon>
              </span>
            </template>
            <span>
              SFP = quantidade de serviços executados pela distribuidora, fora
              do prazo regulatório, em cada categoria de serviço comercial
              <i>i</i>.
            </span>
          </v-tooltip>
        </template>

        <template v-slot:item.psfp="{ item }">
          <span
            v-if="item.psfp !== null && item.psfp !== undefined"
            :style="{ color: getCorPsfp(item.faixa_chave), fontWeight: 'bold' }"
          >
            {{ item.psfp | parseNumberToFloatBrIgnoringNaN }}%
          </span>
          <span
            v-else
            :style="{ color: getCorPsfp(item.faixa_chave), fontWeight: 'bold' }"
          >
            —
          </span>
        </template>

        <template v-slot:header.contribuicao_ponderada_isfp="{ header }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" class="text-no-wrap">
                {{ header.text }}
                <v-icon x-small color="grey">mdi-help-circle-outline</v-icon>
              </span>
            </template>
            <span>
              CPISFP = Contribuição ponderada ISFP
            </span>
          </v-tooltip>
        </template>

        <template v-slot:item.contribuicao_ponderada_isfp="{ item }">
          <span
            v-if="
              item.contribuicao_ponderada_isfp !== null &&
                item.contribuicao_ponderada_isfp !== undefined
            "
          >
            {{
              item.contribuicao_ponderada_isfp | parseNumberToFloatBrIgnoringNaN
            }}
          </span>
          <span v-else>
            —
          </span>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                x-small
                :disabled="loading || item.indice_categoria == null"
                aria-label="Remover da seleção"
                @click.stop="$emit('remover-servico', item.indice_categoria)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Remover da seleção</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DashboardIsfpPsfpTop10PsfpSimulador",
  props: {
    topPsfp: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    selectedCount: { type: Number, default: 0 },
  },
  methods: {
    getCorPsfp(faixaChave) {
      const cores = {
        ate_1: "#4CAF50",
        de_1_a_5: "#8BC34A",
        de_5_a_10: "#FFC107",
        de_10_a_20: "#FF9800",
        acima_20: "#F44336",
      };
      return cores[faixaChave] || "#000";
    },
  },
};
</script>

<style scoped>
.tabela-top10-simulador {
  height: 100%;
}

.tabela-top10-compacta ::v-deep td {
  font-size: 12px !important;
}

.tabela-top10-compacta ::v-deep th {
  font-size: 12px !important;
}

.tabela-top10-compacta ::v-deep td,
.tabela-top10-compacta ::v-deep th {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
</style>
